import {
	Button,
	Checkbox,
	Col,
	Form,
	Input,
	Popconfirm,
	Row,
	Select,
	notification,
	Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
import { rolePouredOptions } from "../../constants/Poured";
const { Text } = Typography;

const Admin = (props) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [apiNotification, contextHolder] = notification.useNotification();
	const [pouredSellers, setPouredSellers] = useState([]);
	const [enabledSelectSellers, setEnabledSelectSellers] = useState(false);

	useEffect(() => {
		getPouredSeller();
		getAdmin();
	}, []);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const duplicatedUserEmail = async (email) => {
		const url = api + "/useremail/" + email;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserPhone = async (phone) => {
		const url = api + `/userphone/+1${phone}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getAdmin = async () => {
		try {
			let url = api + `/users/${props.match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			setInitialValues({
				...initialValues,
				name: data.name,
				email: data.email,
				phone: data.phone ? data.phone.substring(2) : "",
				jobHold: data.jobHold ? data.jobHold : false,
				isPouredUser: data.isPouredUser ? data.isPouredUser : false,
				isActivePouredUser: data.isActivePouredUser
					? data.isActivePouredUser
					: false,
				pouredRole: data.pouredRole || "",
				pouredSellers: data.pouredSellers,
				isQCUser: data.isQCUser || false,
				filePermission: data.filePermission || false,
				prefix: "+1",
				active:
					data.active !== null && data.active !== undefined
						? data.active
						: true,
			});

			if (data.pouredRole === "Admin") {
				setEnabledSelectSellers(true);
			}

			setEmail(data.email);
			setPhone(data.phone);
			setLoading(false);
			setLoadingForm(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get user");
			console.error(err.message);
			return null;
		}
	};

	const updateAdmin = async (data) => {
		const user = {
			name: data.name,
			email: data.email,
			jobHold: data.jobHold ? data.jobHold : false,
			isPouredUser: data.isPouredUser,
			isActivePouredUser: data.isActivePouredUser,
			pouredSellers: data.pouredSellers,
			isQCUser: data.isQCUser || false,
			filePermission: data.filePermission || false,
			phone: `+1${data.phone}`,
			active: data.active || false,
		};

		if (data.pouredRole !== "") {
			user.pouredRole = data.pouredRole;
		}

		if (
			data.password !== undefined &&
			data.password !== null &&
			data.password !== ""
		) {
			user.password = data.password;
		}

		try {
			let url = api + `/users/${props.match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, user);
			openNotification("success", "Success", "Admin created");
			setLoading(false);
			props.history.push("/admin/list");
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update user");
			console.error(err.message);
			return null;
		}
	};

	const deleteAdmin = async () => {
		setLoading(true);

		const url = api + "/users/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			openNotification("info", "Info", "Admin Deleted");
			setLoading(false);
			props.history.push("/admin/list");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const validateUser = async (values) => {
		if ("+1" + values.phone === phone && values.email === email) {
			updateAdmin(values);
		} else {
			let duplicadoEmail = false;
			let duplicadoPhone = false;

			if (values.email !== email) {
				duplicadoEmail = await duplicatedUserEmail(values.email);
			}
			if ("+1" + values.phone !== phone) {
				duplicadoPhone = await duplicatedUserPhone(values.phone);
			}

			if (duplicadoEmail) {
				openNotification(
					"warning",
					"Duplicated user",
					"User already exist with Email",
				);
				setLoading(false);
			} else if (duplicadoPhone) {
				openNotification(
					"warning",
					"Duplicated user",
					"User already exist with Phone",
				);
				setLoading(false);
			} else {
				updateAdmin(values);
			}
		}
	};

	const getPouredSeller = async () => {
		try {
			let url = api + `/user/sellers/poured/get`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setPouredSellers(list);
			} else {
				setLoading(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get sellers");
			console.error(err.message);
			return null;
		}
	};

	const onChangeRole = (value) => {
		if (value === "Admin") {
			setEnabledSelectSellers(true);
		} else {
			setEnabledSelectSellers(false);
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		validateUser(values);
	};

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
				defaultValue={"+1"}
			>
				<Select.Option value="+1">+1</Select.Option>
			</Select>
		</Form.Item>
	);

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				initialValues={initialValues}
				onFinish={onFinish}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Email"
							name="email"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
								{
									required: true,
									message: "Please fill email",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Phone"
							name="phone"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={6}>
						<Form.Item name="active" valuePropName="checked">
							<Checkbox>Active</Checkbox>
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item name="jobHold" valuePropName="checked">
							<Checkbox>Allow Job Hold</Checkbox>
						</Form.Item>
					</Col>
				</Row>
				{(localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "ec@57concrete.com") && (
					<Row gutter={16}>
						<Col span={12}>
							<Form.Item
								name="password"
								label="Change Password"
								rules={[
									{
										min: 5,
										message: "Password must have at least 5 characters",
									},
								]}
								hasFeedback
							>
								<Input.Password size="large" />
							</Form.Item>
						</Col>
					</Row>
				)}
				{(localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "jp@57concrete.com" ||
					localStorage.getItem("email") === "bp@57concrete.com" ||
					localStorage.getItem("email") === "bpa@57concrete.com" ||
					localStorage.getItem("email") === "vm@57concrete.com" ||
					localStorage.getItem("email") === "mgr@57concrete.com" ||
					localStorage.getItem("email") === "jh@57concrete.com" ||
					localStorage.getItem("email") === "jv@57concrete.com" ||
					localStorage.getItem("email") === "ji@57concrete.com") && (
					<Row gutter={16}>
						<Col span={24}>
							<Text strong>Poured Details</Text>
						</Col>
						<Col span={8}>
							<Form.Item name="isPouredUser" valuePropName="checked">
								<Checkbox>Is Poured User? (App)</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item name="isActivePouredUser" valuePropName="checked">
								<Checkbox>Is Active Poured User? (Poured Web)</Checkbox>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="pouredRole" label="Poured Role">
								<Select
									options={rolePouredOptions}
									style={{ width: "100%" }}
									allowClear={false}
									onChange={onChangeRole}
								/>
							</Form.Item>
						</Col>
						{enabledSelectSellers && (
							<Col span={12}>
								<Form.Item name="pouredSellers" label="Poured Sellers">
									<Select
										mode="multiple"
										options={pouredSellers}
										style={{ width: "100%" }}
										allowClear={false}
									/>
								</Form.Item>
							</Col>
						)}
						<Col span={24}>
							<Form.Item name="isQCUser" valuePropName="checked">
								<Checkbox>Is Active QC User?</Checkbox>
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="filePermission" valuePropName="checked">
								<Checkbox>Has File Permission?</Checkbox>
							</Form.Item>
						</Col>
					</Row>
				)}
				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
					{/* <Col>
                    <Popconfirm
                        title="Delete the user"
                        description="Are you sure to delete this user?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={deleteAdmin}
                    >
                        <Button danger type='primary' htmlType='button' loading={loading}>Delete</Button>
                    </Popconfirm>
                </Col> */}
				</Row>
			</Form>
		);
	};

	return (
		<Layout title="Admin" description="Edit Admin" type="medium">
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default Admin;
